exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".barcode[data-v-f19bd106]{width:150px;height:15px}", ""]);

// exports
